/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Main_Characters_PlaceholderInputs */



/**
* | output |
* | --- |
* | "e.g. David, Sarah, the park ranger..." |
*
* @param {Main_Characters_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const main_characters_placeholder = /** @type {((inputs?: Main_Characters_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Main_Characters_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Par exemple, David, Sarah, le garde forestier...")
	if (locale === "de") return /** @type {LocalizedString} */ ("z.B. David, Sarah, der Parkwächter...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ad esempio David, Sarah, il guardaparco...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("например, Дэвид, Сара, смотритель парка...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por ejemplo, David, Sarah, el guardaparques...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("例如：大卫、莎拉、公园管理员……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("例：デイビッド、サラ、公園管理人…")
	if (locale === "hi") return /** @type {LocalizedString} */ ("उदाहरण के लिए, डेविड, सारा, पार्क रेंजर...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por exemplo, David, Sarah, o guarda-parque...")
	return /** @type {LocalizedString} */ ("e.g. David, Sarah, the park ranger...")
});